import BaseView from './base';

export default class MatrixRowView extends BaseView {
    constructor(matrix, row) {
        super(matrix, 1, matrix.columns);
        this.row = row;
    }

    set(rowIndex, columnIndex, value) {
        this.matrix.set(this.row, columnIndex, value);
        return this;
    }

    get(rowIndex, columnIndex) {
        return this.matrix.get(this.row, columnIndex);
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-regression/~/ml-matrix/src/views/row.js
// module id = 237
// module chunks = 0